module.exports = __webpack_public_path__ + "static/img/title_bg.61540787.png";